import { useMutation } from '@tanstack/react-query';
import { useBrokerNewReferralStore } from '../state/useBrokerNewReferralStore';
import { TemplatesApi } from '@apply/api';
import { applicationInsights } from '../../../../../ApplicationInsights';
import { bfiLogo } from '../../../../../common/SharedConstants';

export function useBrokerICCAAgreementActions() {
    const templatesApi = new TemplatesApi.TemplatesApi(applicationInsights);

    const referral = useBrokerNewReferralStore((s) => s.referral);

    const mapToRetrieveICCAAgreement = () => ({
        brokerId: referral.brokerId,
        entityName: referral.businessEntityName,
        principalFirstName: referral.repFirstName,
        principalMiddleName: referral.repMiddleName,
        principalLastName: referral.repLastName,
        principalSuffix: referral.repSuffix,
        logoUrl: bfiLogo,
        clientIsFlagged: referral.clientIsFlagged,
    });

    const signICCAMutation = useMutation({
        mutationFn: async () => {
            const dto = mapToRetrieveICCAAgreement();
            return await templatesApi.signIccaHtml(dto);
        },
    });

    return {
        signICCAAgreement: () => signICCAMutation.mutate(),
        signICCAAgreementAsync: async () => {
            try {
                const data = await signICCAMutation.mutateAsync();
                return { ok: true, data };
            } catch (err: any) {
                return { ok: false, error: err };
            }
        },
    };
}
